module.exports = __webpack_public_path__ + "38d46b5152923efdd557eedbe3a793ce.png";